import React from 'react'
import PropTypes from 'prop-types'

import TCFConsentRow from './TCFConsentRow'


export default function TCFConsentTable(props) {
  const {
    content,
    handleConsentChange,
    // TODO: this needs a better name
    isConsented,
    showVendorCount = true,
    vendorCounts = {},
    vendorType,
  } = props

  if ( !content ) {
    return null
  }

  return content.map((row) => {
    // NOTE: This is us planning for the future. Currently, 'consentable'
    // does not exist on any purpose/special purpose, but it will "inevitably be used in the future."
    // See: https://termly.atlassian.net/browse/TER-13566
    // and/or: https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/IAB%20Tech%20Lab%20-%20Consent%20string%20and%20vendor%20list%20formats%20v2.md
    if ( row.consentable === false ) {
      return null
    }

    const isChecked = isConsented(row.id)
    const vendorCount = vendorCounts[row.id]

    return (
      <TCFConsentRow
        handleConsentChange={ handleConsentChange }
        isChecked={ isChecked }
        key={ row.name }
        row={ row }
        showVendorCount={ showVendorCount }
        vendorCount={ vendorCount }
        vendorType={ vendorType }
      />
    )
  })
}

TCFConsentTable.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })),
  handleConsentChange: PropTypes.func.isRequired,
  isConsented: PropTypes.func.isRequired,
  vendorType: PropTypes.string.isRequired,

  showVendorCount: PropTypes.bool,
  vendorCounts: PropTypes.objectOf(
    PropTypes.number
  ),
}
